export type Nivel = 'verde' | 'portocaliu' | 'rosu'
export type EticheteStatus = 'Draft' | 'InRevizie' | 'Aprobata' | 'Tiparita' | 'Arhivata'

export interface EfsaIngredient {
  id: number
  key: string
  label: string
  grupa: string
  nivel: Nivel
  reg: string
  mentiune: string
  conditii: string | null
  ul: string | null
  ulUnit: string | null
  descriereLegala: string | null
  cuvinteCheie: string[]
}

export interface LabelStandard {
  id: number
  tip: 'avertizare' | 'vnr' | 'marca' | 'website' | 'alt'
  cheie: string
  valoare: string
  editabil: boolean
  sortOrder: number
}

export interface IngredientItem {
  key: string
  label: string
  doza: string
  mentiune: string
  nivel: Nivel
}

export interface BeneficiuItem {
  text: string
  status: 'verde' | 'portocaliu' | 'rosu' | 'gol'
}

export interface Eticheta {
  id: number
  idIntern: string
  tip: 'tip1' | 'tip2'
  denumire: string
  subtitlu: string | null
  portii: string | null
  forma: string | null
  gramaj: string | null
  madeIn: string | null
  ingrediente: IngredientItem[]
  mentiune: string | null
  beneficii: BeneficiuItem[]
  compozitie: string | null
  utilizareAdulti: string | null
  utilizareCopii: string | null
  tara: string | null
  adresa: string | null
  autoritate: string | null
  notificare: string | null
  detinator: string | null
  ean: string | null
  avertSpecific: string | null
  pictograme: string[]
  dimW: number | null
  dimH: number | null
  hasRosu: boolean
  status: EticheteStatus
  createdAt: string
  updatedAt: string
  creatDe: { id: number; name: string } | null
  aprobatDe: { id: number; name: string } | null
  aprobatLa: string | null
}

export const PICTOGRAME = [
  'VEGAN',
  'VEGETARIAN',
  'FARA_GLUTEN',
  'FARA_LACTOZA',
  'FARA_ZAHAR',
  'FARA_AROME',
] as const

export const FORME = ['Capsule vegane', 'Capsule moi', 'Pudra', 'Tablete'] as const

export const MADE_IN_OPTIONS = [
  { value: '', label: '— fără mențiune —' },
  { value: 'MADE IN GERMANY', label: 'MADE IN GERMANY' },
  { value: 'MADE IN EU', label: 'MADE IN EU' },
  { value: 'MADE IN EUROPE', label: 'MADE IN EUROPE' },
  { value: 'custom', label: 'Altul (editabil)…' },
]

export const AUTORITATI = ['CRSP-C', 'Ministerul Sănătății', 'IBA'] as const

/**
 * Etichetele salvate inainte de 20.10.2026 au autoritatea scrisa fara diacritice. Se citesc in
 * forma corecta, ca sa apara alese in lista si corect pe eticheta tiparita.
 */
export const autoritateCorecta = (a: string | null | undefined): string | null =>
  a === 'Ministerul Sanatatii' ? 'Ministerul Sănătății' : (a ?? null)

export const STATUS_LABELS: Record<EticheteStatus, string> = {
  Draft: 'Ciornă',
  InRevizie: 'În revizie',
  Aprobata: 'Aprobată',
  Tiparita: 'Tipărită',
  Arhivata: 'Arhivată',
}

export const STATUS_COLORS: Record<EticheteStatus, string> = {
  Draft: 'bg-b4l-bg text-b4l-text-muted',
  InRevizie: 'bg-b4l-amber-light text-b4l-amber-dark',
  Aprobata: 'bg-b4l-green-light text-b4l-green-dark',
  Tiparita: 'bg-b4l-blue-light text-b4l-blue-dark',
  Arhivata: 'bg-b4l-bg text-b4l-text-dim',
}

export const NIVEL_COLORS: Record<Nivel, string> = {
  verde: 'bg-b4l-green-light text-b4l-green-dark',
  portocaliu: 'bg-b4l-amber-light text-b4l-amber-dark',
  rosu: 'bg-b4l-red-light text-b4l-red-dark',
}

export const NIVEL_DOTS: Record<Nivel, string> = {
  verde: 'bg-b4l-green',
  portocaliu: 'bg-b4l-amber',
  rosu: 'bg-b4l-red',
}

export const DIM_PRESETS = [
  { label: '170 x 70 mm (std 60 cps)', w: 170, h: 70 },
  { label: '190 x 80 mm (90 cps)', w: 190, h: 80 },
  { label: '280 x 100 mm (pudră 300g)', w: 280, h: 100 },
  { label: '320 x 115 mm (pudră 500g)', w: 320, h: 115 },
  { label: '120 x 190 mm (cutie)', w: 120, h: 190 },
]
